import type { Stage } from '@one-deployment/shared'

/**
 * Stage → presentation (03 §6): the only source of status colour, and always
 * colour + icon + word, never colour alone. The Worker decides the stage; this
 * only paints it.
 */
export type StageLook = { label: string; icon: string; text: string; dot: string; hollow?: boolean }

export const STAGE_LOOK: Record<Stage, StageLook> = {
  queued: { label: 'queued', icon: '○', text: 'text-fg-subtle', dot: 'bg-fg-subtle' },
  triage: { label: 'triage', icon: '◐', text: 'text-info', dot: 'bg-info' },
  triaged: { label: 'triaged', icon: '○', text: 'text-fg-muted', dot: 'bg-fg-subtle' },
  declined: { label: 'declined', icon: '!', text: 'text-warn', dot: 'bg-warn' },
  implementing: { label: 'working', icon: '●', text: 'text-info', dot: 'bg-info' },
  verifying: { label: 'checking', icon: '◐', text: 'text-info', dot: 'bg-info', hollow: true },
  proving: { label: 'proving', icon: '◐', text: 'text-info', dot: 'bg-info', hollow: true },
  pr_open: { label: 'PR open', icon: '◉', text: 'text-accent-hover', dot: 'bg-accent' },
  pr_pending: { label: 'PR queued', icon: '◉', text: 'text-warn', dot: 'bg-warn', hollow: true },
  paused: { label: 'paused', icon: '‖', text: 'text-fg-faint', dot: 'bg-fg-faint' },
  needs_human: { label: 'needs you', icon: '!', text: 'text-warn', dot: 'bg-warn' },
  merged: { label: 'merged', icon: '✓', text: 'text-merged', dot: 'bg-merged' },
  done_elsewhere: { label: 'already done elsewhere', icon: '✓', text: 'text-merged', dot: 'bg-merged' },
  dropped: { label: 'dropped', icon: '✕', text: 'text-err', dot: 'bg-err' },
  testing: { label: 'testing', icon: '◐', text: 'text-info', dot: 'bg-info' },
  verified: { label: 'verified', icon: '✓', text: 'text-ok', dot: 'bg-ok' },
  rejected: { label: 'rejected', icon: '✕', text: 'text-err', dot: 'bg-err' },
}

/** Board columns (03 §5.6): the five a person scans, built from the stage machine. */
export const BOARD_COLUMNS: { key: string; label: string; stages: Stage[] }[] = [
  { key: 'queued', label: 'Queued', stages: ['triaged', 'queued'] },
  { key: 'working', label: 'Working', stages: ['triage', 'implementing', 'testing'] },
  { key: 'checking', label: 'Checking', stages: ['verifying', 'proving'] },
  { key: 'pr', label: 'PR open', stages: ['pr_open', 'pr_pending'] },
  { key: 'needs', label: 'Needs you', stages: ['needs_human', 'declined', 'rejected', 'paused'] },
]
